module.exports = __webpack_public_path__ + "listening_test.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/testPages/listening_test/assets/listening_test.mp3
// module id = 717
// module chunks = 0